import React, { useEffect, useState, useRef } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { BookOpen, Users, Briefcase, Music, ArrowRight, CheckCircle2, Calendar, Recycle, X, Loader2, GraduationCap, Award, Sparkles, Building2, Handshake, UserPlus, PartyPopper, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { saveSubmission } from '../services/databaseService';
import { sendViaWeb3Forms } from '../services/web3formsService';
type ModalType = 'ateliers' | 'festival' | 'employeur' | 'recruter' | 'partenariat' | 'recyclage' | null;
export function ActionsPage() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formationAutre, setFormationAutre] = useState('');
  const [showFormationAutre, setShowFormationAutre] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  // Auto-open ateliers modal if URL contains #inscription
  useEffect(() => {
    if (window.location.hash === '#inscription') {
      setActiveModal('ateliers');
      // Clean the hash without page reload
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData(formRef.current!);
    const data: Record<string, any> = {};
    formData.forEach((value, key) => {
      if (data[key]) {
        // Handle multiple values (checkboxes)
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    });
    // Map form data to submission types
    let submission: any = {
      type: ''
    };
    if (activeModal === 'ateliers') {
      submission = {
        type: 'atelier',
        nom: data.nom || '',
        prenom: data.prenom || '',
        telephone: data.telephone || '',
        email: data.email || '',
        ville: data.ville || '',
        quartier: data.quartier || '',
        sexe: data.sexe || '',
        dateNaissance: data.dateNaissance || '',
        situation: data.situation || '',
        niveauEtudes: data.niveauEtudes || '',
        formationSouhaitee: data.formationSouhaitee || '',
        formationAutre: data.formationAutre || '',
        source: data.source || ''
      };
    } else if (activeModal === 'festival') {
      submission = {
        type: 'festival',
        nom: data.nom || '',
        prenom: data.prenom || '',
        telephone: data.telephone || '',
        email: data.email || '',
        participation: data.participation || '',
        organisation: data.organisation || ''
      };
    } else if (activeModal === 'employeur') {
      submission = {
        type: 'employeur',
        nomEmployeur: data.nomEmployeur || '',
        typeEmployeur: data.typeEmployeur || '',
        nomContact: data.nomContact || '',
        telephone: data.telephone || '',
        email: data.email || '',
        ville: data.ville || '',
        profilsRecherches: data.profilsRecherches || '',
        attentes: data.attentes || ''
      };
    } else if (activeModal === 'recyclage') {
      submission = {
        type: 'recyclage',
        nomEmployeur: data.nomEmployeur || '',
        nomEmploye: data.nomEmploye || '',
        posteActuel: data.posteActuel || '',
        anciennete: data.anciennete || '',
        telephoneEmploye: data.telephoneEmploye || '',
        pointsFormation: Array.isArray(data.pointsFormation) ? data.pointsFormation.join(', ') : data.pointsFormation || '',
        autresPoints: data.autresPoints || '',
        periodeSouhaitee: data.periodeSouhaitee || '',
        dureeSouhaitee: data.dureeSouhaitee || '',
        observations: data.observations || ''
      };
    }
    setTimeout(async () => {
      try {
        saveSubmission(submission);
        // Envoyer via Web3Forms
        const formData2 = new FormData(formRef.current!);
        const fields: Record<string, string> = {};
        formData2.forEach((value, key) => {
          if (typeof value === 'string') {
            fields[key] = value;
          } else if (Array.isArray(value)) {
            fields[key] = value.join(', ');
          }
        });
        // Gérer les checkboxes multiples pour le recyclage
        if (activeModal === 'recyclage') {
          const pointsFormation = formData2.getAll('pointsFormation');
          if (pointsFormation.length > 0) {
            fields['pointsFormation'] = pointsFormation.join(', ');
          }
        }
        const web3Result = await sendViaWeb3Forms({
          type: activeModal!,
          fields
        });
        console.log(`📋 ${activeModal} submission result:`, web3Result);
        setIsSubmitting(false);
        setIsSuccess(true);
      } catch (error) {
        console.error('Error saving submission:', error);
        setIsSubmitting(false);
        // Show success anyway to not block user
        setIsSuccess(true);
      }
    }, 1000);
  };
  const closeModal = () => {
    setActiveModal(null);
    setIsSuccess(false);
    setShowFormationAutre(false);
    setFormationAutre('');
  };
  const inputClass = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all';
  const selectClass = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white';
  const labelClass = 'text-sm font-medium text-gray-700';
  const modalConfigs = {
    ateliers: {
      title: 'Inscription aux Ateliers',
      subtitle: 'Remplissez ce formulaire pour participer à nos prochaines sessions de formation.',
      successMessage: "Votre demande d'inscription a été enregistrée. Notre équipe vous contactera pour valider votre participation.",
      icon: GraduationCap
    },
    festival: {
      title: 'Participation au Festival',
      subtitle: 'Inscrivez-vous pour participer à notre prochain événement.',
      successMessage: 'Votre inscription au festival est confirmée. Vous recevrez le programme détaillé par email.',
      icon: PartyPopper
    },
    employeur: {
      title: 'Devenir Employeur Partenaire',
      subtitle: "Recrutez du personnel qualifié et formé par l'ADCC.",
      successMessage: 'Votre demande de partenariat a été reçue. Notre équipe vous contactera dans les plus brefs délais.',
      icon: Building2
    },
    recruter: {
      title: 'Recruter un Personnel Formé',
      subtitle: 'Décrivez vos besoins et nous vous mettrons en relation avec des profils qualifiés',
      successMessage: 'Demande reçue ! Nous vous proposerons des profils correspondant à vos critères.',
      icon: Briefcase
    },
    partenariat: {
      title: 'Devenir Partenaire',
      subtitle: "Associez votre image à l'ADCC et soutenez l'insertion professionnelle",
      successMessage: 'Proposition de partenariat reçue ! Notre équipe vous contactera pour en discuter.',
      icon: Handshake
    },
    recyclage: {
      title: 'Demande de Recyclage',
      subtitle: 'Mettez à jour vos compétences avec nos modules de formation continue.',
      successMessage: 'Votre demande de recyclage a été enregistrée. Nous vous contacterons pour planifier votre session.',
      icon: RefreshCw
    }
  };
  return <Layout data-id="element-192">
      <SEO {...pageSEO.actions} data-id="element-193" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16 md:py-24" data-id="element-194">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-195">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-4" data-id="element-196">
            Nos Actions
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-197">
            Agir pour l'autonomisation
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-198">
            Découvrez nos programmes de formation, d'accompagnement et
            d'insertion professionnelle au Bénin.
          </p>
        </div>
      </div>

      {/* Four Pillars Introduction */}
      <section className="py-16 bg-white" data-id="element-199">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-201">
            {[{
            icon: BookOpen,
            title: 'Développement des Compétences',
            desc: 'Acquisition de compétences techniques'
          }, {
            icon: Users,
            title: 'Valorisation Sociale',
            desc: 'Reconnaissance et dignité des métiers de service'
          }, {
            icon: Briefcase,
            title: 'Insertion & Suivi',
            desc: 'Accompagnement vers un emploi durable'
          }, {
            icon: Recycle,
            title: 'Recyclage',
            desc: 'Reconversion et mise à jour des compétences'
          }].map((pillar, index) => <Card key={index} className="text-center border-t-4 border-t-[#1E88E5] hover:shadow-lg transition-shadow duration-300" data-id="element-202">
                <CardContent className="pt-8 pb-6" data-id="element-203">
                  <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-4" data-id="element-204">
                    <pillar.icon className="w-8 h-8 text-[#1E88E5]" data-id="element-205" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-206">
                    {pillar.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-207">{pillar.desc}</p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Main Programs - Restructured */}
      <div className="bg-gray-50" data-id="element-208">
        {/* Festival Section */}
        <section className="py-20" data-id="element-209">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm mb-2 block" data-id="element-211">
              VALORISATION & NETWORKING
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12" data-id="element-212">
              Festival des Personnels de Maison – Juin 2026
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-213">
              <div data-id="element-214">
                <p className="text-lg text-gray-600 mb-8" data-id="element-215">
                  Un événement unique célébrant la dignité et les compétences
                  des personnels de maison, combinant valorisation culturelle et
                  opportunités professionnelles.
                </p>

                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mb-8" data-id="element-216">
                  <h3 className="font-bold text-gray-900 mb-4" data-id="element-217">
                    Au programme :
                  </h3>
                  <ul className="space-y-4" data-id="element-218">
                    {['Exhibitions culturelles et témoignages inspirants', 'Forum de rencontres professionnelles', 'Présentation de profils qualifiés aux employeurs', 'Ateliers de networking et speed meeting', "Création de partenariats avec l'emploi"].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-219">
                        <CheckCircle2 className="w-5 h-5 text-[#1E88E5] flex-shrink-0 mt-0.5" data-id="element-220" />
                        <span className="text-gray-700" data-id="element-221">{item}</span>
                      </li>)}
                  </ul>
                </div>

                <Button onClick={() => setActiveModal('festival')} className="w-full sm:w-auto gap-2 bg-[#2C3E50] hover:bg-[#1a252f]" size="lg" data-id="element-222">
                  <PartyPopper className="w-5 h-5" data-id="element-223" />
                  Participer au festival
                </Button>
              </div>

              <div className="relative" data-id="element-224">
                <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&q=80&w=800" alt="Festival des Personnels de Maison" className="rounded-2xl shadow-xl w-full object-cover h-[400px]" data-id="element-225" />
                <div className="absolute top-4 right-4 bg-white rounded-full px-4 py-2 shadow-lg flex items-center gap-2" data-id="element-226">
                  <Calendar className="w-4 h-4 text-[#1E88E5]" data-id="element-227" />
                  <span className="font-bold text-gray-900 text-sm" data-id="element-228">
                    Juin 2026
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Insertion & Suivi Section */}
        <section className="py-20 bg-white" data-id="element-229">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
            <div className="text-center mb-16" data-id="element-231">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm mb-2 block" data-id="element-232">
                AUTRE PILIER STRATÉGIQUE
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-233">
                Insertion & Suivi Professionnels
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-234">
                L'ADCC met en place un dispositif d'accompagnement continu de
                personnels qui ont suivi nos ateliers, en collaboration avec des
                familles, entreprises, institutions et partenaires.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-235">
              {/* Left Column - Ce que nous proposons */}
              <Card className="border border-gray-100 shadow-sm" data-id="element-236">
                <CardContent className="p-8" data-id="element-237">
                  <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-238">
                    Ce que nous proposons
                  </h3>
                  <div className="space-y-5" data-id="element-239">
                    {[{
                    title: 'Identification des besoins et préparation des profils',
                    desc: 'Évaluation des compétences et matching avec les besoins'
                  }, {
                    title: 'Mise en relation avec des employeurs',
                    desc: 'Réseau de familles, entreprises et structures partenaires'
                  }, {
                    title: "Sensibilisation aux bonnes pratiques d'emploi",
                    desc: 'Accompagnement des employeurs au respect des droits'
                  }, {
                    title: 'Suivi post-placement et médiation si nécessaire',
                    desc: 'Accompagnement continu pour garantir la durabilité'
                  }].map((item, idx) => <div key={idx} className="flex gap-3" data-id="element-240">
                        <div className="w-2.5 h-2.5 rounded-full bg-amber-400 flex-shrink-0 mt-2" data-id="element-241" />
                        <div data-id="element-242">
                          <h4 className="font-bold text-gray-900" data-id="element-243">
                            {item.title}
                          </h4>
                          <p className="text-sm text-gray-500" data-id="element-244">{item.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </CardContent>
              </Card>

              {/* Right Column - Notre Objectif */}
              <Card className="bg-[#1E88E5] text-white border-none shadow-lg flex flex-col" data-id="element-245">
                <CardContent className="p-8 flex-grow flex flex-col" data-id="element-246">
                  <h3 className="text-xl font-bold mb-4" data-id="element-247">Notre Objectif</h3>
                  <p className="text-blue-100 mb-8" data-id="element-248">
                    Créer un cadre structuré, sécurisé et respectueux pour
                    l'emploi des personnels de maison et de services.
                  </p>

                  <div className="space-y-5 mb-8 flex-grow" data-id="element-249">
                    <div className="flex items-center gap-4" data-id="element-250">
                      <div className="w-3 h-3 rounded-full bg-green-400 flex-shrink-0" data-id="element-251" />
                      <div data-id="element-252">
                        <h4 className="font-bold text-green-300" data-id="element-253">Dignité</h4>
                        <p className="text-sm text-blue-100" data-id="element-254">
                          Respect des droits et de la personne
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-4" data-id="element-255">
                      <div className="w-3 h-3 rounded-full bg-blue-300 flex-shrink-0" data-id="element-256" />
                      <div data-id="element-257">
                        <h4 className="font-bold text-blue-200" data-id="element-258">
                          Transparence
                        </h4>
                        <p className="text-sm text-blue-100" data-id="element-259">
                          Clarté sur les conditions d'emploi
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-4" data-id="element-260">
                      <div className="w-3 h-3 rounded-full bg-amber-400 flex-shrink-0" data-id="element-261" />
                      <div data-id="element-262">
                        <h4 className="font-bold text-amber-300" data-id="element-263">Durabilité</h4>
                        <p className="text-sm text-blue-100" data-id="element-264">
                          Insertion professionnelle à long terme
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-3 mt-auto" data-id="element-265">
                    <Button onClick={() => setActiveModal('employeur')} variant="outline" className="w-full border-white text-white hover:bg-white/10 hover:text-white gap-2" data-id="element-266">
                      <Building2 className="w-4 h-4" data-id="element-267" />
                      Devenir employeur partenaire
                    </Button>
                    <Button onClick={() => setActiveModal('recyclage')} variant="outline" className="w-full border-white text-white hover:bg-white/10 hover:text-white gap-2" data-id="element-268">
                      <RefreshCw className="w-4 h-4" data-id="element-269" />
                      Recycler mon employé
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* Engagement Banner */}
        <section className="py-12 bg-gray-50" data-id="element-270">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-271">
            <div className="bg-gradient-to-r from-[#1E88E5] to-[#1565C0] rounded-2xl p-10 text-center text-white shadow-xl" data-id="element-272">
              <h3 className="text-2xl md:text-3xl font-bold italic mb-4" data-id="element-273">
                "Notre engagement : transformer les compétences en opportunités
                d'emploi."
              </h3>
              <p className="text-blue-100" data-id="element-274">
                L'insertion professionnelle constitue un indicateur clé de
                réussite de nos programmes.
              </p>
            </div>
          </div>
        </section>

        {/* Partenaires CTA */}
        <section className="py-20 bg-white" data-id="element-275">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-276">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-277">
              Rejoignez notre réseau de partenaires
            </h2>
            <p className="text-lg text-gray-600 mb-10" data-id="element-278">
              Que vous soyez une famille, une entreprise ou une institution,
              devenez partenaire de l'ADCC pour favoriser l'insertion
              professionnelle digne.
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4" data-id="element-279">
              <Button onClick={() => setActiveModal('employeur')} size="lg" className="gap-2 bg-[#1E88E5] hover:bg-[#1976D2]" data-id="element-280">
                <UserPlus className="w-5 h-5" data-id="element-281" />
                Recruter un personnel compétent
              </Button>
              <Button onClick={() => window.location.href = '/partner'} variant="outline" size="lg" className="gap-2 bg-[#2C3E50] text-white hover:bg-[#1a252f] border-none" data-id="element-282">
                <Handshake className="w-5 h-5" data-id="element-283" />
                Proposer un partenariat
              </Button>
              <Button onClick={() => setActiveModal('recyclage')} variant="outline" size="lg" className="gap-2 bg-[#2C3E50] text-white hover:bg-[#1a252f] border-none" data-id="element-284">
                <RefreshCw className="w-5 h-5" data-id="element-285" />
                Recycler mon employé
              </Button>
            </div>
          </div>
        </section>

        {/* Droit à l'image */}
        <section className="py-8 pb-16" data-id="element-286">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-287">
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-6" data-id="element-288">
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-289">
                <span className="font-semibold text-gray-900" data-id="element-290">
                  📷 Droit à l'image :
                </span>{' '}
                En participant aux activités ADCC (formations, ateliers, foires,
                événements), vous autorisez ADCC à utiliser votre image (photos
                et vidéos) réalisées lors de ces activités à des fins de
                communication institutionnelle et promotionnelle sur le site
                adcc.africa et les supports numériques et imprimés associés.
                Cette autorisation peut être retirée à tout moment par demande
                écrite adressée à ADCC, sans effet rétroactif sur les contenus
                déjà publiés.
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* Modals */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto" data-id="element-291">
          <div className="bg-white rounded-2xl w-full max-w-2xl shadow-2xl my-8 relative max-h-[90vh] overflow-y-auto" data-id="element-292">
            <button onClick={closeModal} className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 text-gray-500 transition-colors z-10" data-id="element-293">
              <X className="w-6 h-6" data-id="element-294" />
            </button>

            <div className="p-8" data-id="element-295">
              <div className="text-center mb-8" data-id="element-296">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1E88E5] rounded-full mb-4" data-id="element-297">
                  {activeModal === 'ateliers' && <GraduationCap className="w-8 h-8 text-white" data-id="element-298" />}
                  {activeModal === 'festival' && <PartyPopper className="w-8 h-8 text-white" data-id="element-299" />}
                  {activeModal === 'employeur' && <Building2 className="w-8 h-8 text-white" data-id="element-300" />}
                  {activeModal === 'recyclage' && <RefreshCw className="w-8 h-8 text-white" data-id="element-301" />}
                </div>
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-302">
                  {/* @ts-ignore */}
                  {modalConfigs[activeModal]?.title}
                </h2>
                <p className="text-gray-600 mt-2" data-id="element-303">
                  {/* @ts-ignore */}
                  {modalConfigs[activeModal]?.subtitle}
                </p>
              </div>

              {isSuccess ? <div className="text-center py-12" data-id="element-304">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-305">
                    <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-306" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-307">
                    {activeModal === 'ateliers' && 'Inscription enregistrée !'}
                    {activeModal === 'festival' && 'Inscription confirmée !'}
                    {activeModal === 'employeur' && 'Demande reçue !'}
                    {activeModal === 'recyclage' && 'Demande enregistrée !'}
                  </h3>
                  <p className="text-gray-600 mb-8" data-id="element-308">
                    {/* @ts-ignore */}
                    {modalConfigs[activeModal]?.successMessage}
                  </p>
                  <Button onClick={closeModal} data-id="element-309">Fermer</Button>
                </div> : <form ref={formRef} onSubmit={handleSubmit} className="space-y-6" data-id="element-310">
                  {/* Formulaire Ateliers */}
                  {activeModal === 'ateliers' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-311">
                      <div className="space-y-2" data-id="element-312">
                        <label className={labelClass} data-id="element-313">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom de famille" data-id="element-314" />
                      </div>
                      <div className="space-y-2" data-id="element-315">
                        <label className={labelClass} data-id="element-316">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-317" />
                      </div>
                      <div className="space-y-2" data-id="element-318">
                        <label className={labelClass} data-id="element-319">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="votre@email.com" data-id="element-320" />
                      </div>
                      <div className="space-y-2" data-id="element-321">
                        <label className={labelClass} data-id="element-322">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-323" />
                      </div>
                      <div className="space-y-2" data-id="element-324">
                        <label className={labelClass} data-id="element-325">Ville / Commune *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-326" />
                      </div>
                      <div className="space-y-2" data-id="element-327">
                        <label className={labelClass} data-id="element-328">Quartier *</label>
                        <input name="quartier" type="text" required className={inputClass} placeholder="Ex: Haie Vive" data-id="element-329" />
                      </div>
                      <div className="space-y-2" data-id="element-330">
                        <label className={labelClass} data-id="element-331">
                          Date de naissance *
                        </label>
                        <input name="dateNaissance" type="date" required className={inputClass} data-id="element-332" />
                      </div>
                      <div className="space-y-2" data-id="element-333">
                        <label className={labelClass} data-id="element-334">Sexe *</label>
                        <select name="sexe" required className={selectClass} data-id="element-335">
                          <option value="" data-id="element-336">Sélectionnez...</option>
                          <option value="Féminin" data-id="element-337">Féminin</option>
                          <option value="Masculin" data-id="element-338">Masculin</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-339">
                        <label className={labelClass} data-id="element-340">
                          Situation actuelle *
                        </label>
                        <select name="situation" required className={selectClass} data-id="element-341">
                          <option value="" data-id="element-342">Sélectionnez...</option>
                          <option value="Étudiant(e)" data-id="element-343">Étudiant(e)</option>
                          <option value="En recherche d'emploi" data-id="element-344">
                            En recherche d'emploi
                          </option>
                          <option value="En emploi" data-id="element-345">En emploi</option>
                          <option value="Autre" data-id="element-346">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-347">
                        <label className={labelClass} data-id="element-348">Niveau d'études *</label>
                        <select name="niveauEtudes" required className={selectClass} data-id="element-349">
                          <option value="" data-id="element-350">Sélectionnez...</option>
                          <option value="Aucun" data-id="element-351">Aucun</option>
                          <option value="Primaire" data-id="element-352">Primaire</option>
                          <option value="Secondaire" data-id="element-353">Secondaire</option>
                          <option value="Supérieur" data-id="element-354">Supérieur</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-355">
                        <label className={labelClass} data-id="element-356">
                          Formation souhaitée *
                        </label>
                        <select name="formationSouhaitee" required className={selectClass} onChange={e => setShowFormationAutre(e.target.value === 'Autre')} data-id="element-357">
                          <option value="" data-id="element-358">Sélectionnez...</option>
                          <option value="Personnel de maison" data-id="element-359">
                            Personnel de maison (Nounou, Cuisinier...)
                          </option>
                          <option value="Hôtellerie / Restauration" data-id="element-360">
                            Hôtellerie / Restauration
                          </option>
                          <option value="Aide à la personne" data-id="element-361">
                            Aide à la personne
                          </option>
                          <option value="Autre" data-id="element-362">Autre</option>
                        </select>
                      </div>
                      {showFormationAutre && <div className="space-y-2 md:col-span-2" data-id="element-363">
                          <label className={labelClass} data-id="element-364">
                            Précisez la formation souhaitée *
                          </label>
                          <input name="formationAutre" type="text" required className={inputClass} placeholder="Quelle formation ?" data-id="element-365" />
                        </div>}
                      <div className="space-y-2 md:col-span-2" data-id="element-366">
                        <label className={labelClass} data-id="element-367">
                          Comment avez-vous connu l'ADCC ? *
                        </label>
                        <select name="source" required className={selectClass} data-id="element-368">
                          <option value="" data-id="element-369">Sélectionnez...</option>
                          <option value="Réseaux sociaux" data-id="element-370">
                            Réseaux sociaux
                          </option>
                          <option value="Bouche à oreille" data-id="element-371">
                            Bouche à oreille
                          </option>
                          <option value="Radio / TV" data-id="element-372">Radio / TV</option>
                          <option value="Autre" data-id="element-373">Autre</option>
                        </select>
                      </div>
                    </div>}

                  {/* Formulaire Festival */}
                  {activeModal === 'festival' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-374">
                      <div className="space-y-2" data-id="element-375">
                        <label className={labelClass} data-id="element-376">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom de famille" data-id="element-377" />
                      </div>
                      <div className="space-y-2" data-id="element-378">
                        <label className={labelClass} data-id="element-379">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-380" />
                      </div>
                      <div className="space-y-2" data-id="element-381">
                        <label className={labelClass} data-id="element-382">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="votre@email.com" data-id="element-383" />
                      </div>
                      <div className="space-y-2" data-id="element-384">
                        <label className={labelClass} data-id="element-385">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-386" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-387">
                        <label className={labelClass} data-id="element-388">
                          Vous souhaitez participer en tant que : *
                        </label>
                        <select name="participation" required className={selectClass} data-id="element-389">
                          <option value="" data-id="element-390">Sélectionnez...</option>
                          <option value="Visiteur / Chercheur d'emploi" data-id="element-391">
                            Visiteur / Chercheur d'emploi
                          </option>
                          <option value="Employeur / Recruteur" data-id="element-392">
                            Employeur / Recruteur
                          </option>
                          <option value="Partenaire / Sponsor" data-id="element-393">
                            Partenaire / Sponsor
                          </option>
                          <option value="Autre" data-id="element-394">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-395">
                        <label className={labelClass} data-id="element-396">
                          Organisation (Optionnel)
                        </label>
                        <input name="organisation" type="text" className={inputClass} placeholder="Nom de votre entreprise ou association" data-id="element-397" />
                      </div>
                      <div className="md:col-span-2 bg-amber-50 border border-amber-200 rounded-lg p-4" data-id="element-398">
                        <p className="text-xs text-gray-600 leading-relaxed" data-id="element-399">
                          <span className="font-semibold text-gray-800" data-id="element-400">
                            📷 Droit à l'image :
                          </span>{' '}
                          En participant aux activités ADCC (formations,
                          ateliers, foires, événements), vous autorisez ADCC à
                          utiliser votre image (photos et vidéos) réalisées lors
                          de ces activités à des fins de communication
                          institutionnelle et promotionnelle sur le site
                          adcc.africa et les supports numériques et imprimés
                          associés. Cette autorisation peut être retirée à tout
                          moment par demande écrite adressée à ADCC, sans effet
                          rétroactif sur les contenus déjà publiés.
                        </p>
                      </div>
                    </div>}

                  {/* Formulaire Employeur */}
                  {activeModal === 'employeur' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-401">
                      <div className="space-y-2 md:col-span-2" data-id="element-402">
                        <label className={labelClass} data-id="element-403">
                          Nom de l'entreprise / Famille *
                        </label>
                        <input name="nomEmployeur" type="text" required className={inputClass} placeholder="Ex: Hôtel Azalaï" data-id="element-404" />
                      </div>
                      <div className="space-y-2" data-id="element-405">
                        <label className={labelClass} data-id="element-406">Nom du contact *</label>
                        <input name="nomContact" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-407" />
                      </div>
                      <div className="space-y-2" data-id="element-408">
                        <label className={labelClass} data-id="element-409">Type d'employeur *</label>
                        <select name="typeEmployeur" required className={selectClass} data-id="element-410">
                          <option value="" data-id="element-411">Sélectionnez...</option>
                          <option value="Famille (particulier)" data-id="element-412">
                            Famille (particulier)
                          </option>
                          <option value="Entreprise" data-id="element-413">Entreprise</option>
                          <option value="Institution / ONG" data-id="element-414">
                            Institution / ONG
                          </option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-415">
                        <label className={labelClass} data-id="element-416">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="votre@email.com" data-id="element-417" />
                      </div>
                      <div className="space-y-2" data-id="element-418">
                        <label className={labelClass} data-id="element-419">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-420" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-421">
                        <label className={labelClass} data-id="element-422">Ville / Commune *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-423" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-424">
                        <label className={labelClass} data-id="element-425">
                          Profils recherchés *
                        </label>
                        <input name="profilsRecherches" type="text" required className={inputClass} placeholder="Ex: Cuisinier, Réceptionniste..." data-id="element-426" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-427">
                        <label className={labelClass} data-id="element-428">Vos attentes *</label>
                        <textarea name="attentes" required rows={3} className={inputClass} placeholder="Qu'attendez-vous de l'ADCC ?" data-id="element-429"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Recyclage */}
                  {activeModal === 'recyclage' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-430">
                      <div className="space-y-2 md:col-span-2" data-id="element-431">
                        <label className={labelClass} data-id="element-432">
                          Nom de l'entreprise / Famille *
                        </label>
                        <input name="nomEmployeur" type="text" required className={inputClass} placeholder="Ex: Hôtel Azalaï" data-id="element-433" />
                      </div>
                      <div className="space-y-2" data-id="element-434">
                        <label className={labelClass} data-id="element-435">
                          Nom de l'employé(e) *
                        </label>
                        <input name="nomEmploye" type="text" required className={inputClass} placeholder="Nom de la personne à former" data-id="element-436" />
                      </div>
                      <div className="space-y-2" data-id="element-437">
                        <label className={labelClass} data-id="element-438">Poste actuel *</label>
                        <input name="posteActuel" type="text" required className={inputClass} placeholder="Ex: Cuisinier" data-id="element-439" />
                      </div>
                      <div className="space-y-2" data-id="element-440">
                        <label className={labelClass} data-id="element-441">Ancienneté *</label>
                        <input name="anciennete" type="text" required className={inputClass} placeholder="Ex: 2 ans" data-id="element-442" />
                      </div>
                      <div className="space-y-2" data-id="element-443">
                        <label className={labelClass} data-id="element-444">
                          Téléphone de l'employé(e) *
                        </label>
                        <input name="telephoneEmploye" type="tel" required className={inputClass} placeholder="+229..." data-id="element-445" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-446">
                        <label className={labelClass} data-id="element-447">
                          Points à améliorer *
                        </label>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2" data-id="element-448">
                          {['Hygiène et propreté', 'Service client / Accueil', 'Cuisine / Restauration', 'Gestion du temps', 'Savoir-être professionnel', 'Sécurité au travail'].map(point => <label key={point} className="flex items-center space-x-3 p-3 border rounded-lg hover:bg-gray-50 cursor-pointer" data-id="element-449">
                              <input type="checkbox" name="pointsFormation" value={point} className="w-4 h-4 text-[#1E88E5] border-gray-300 rounded focus:ring-[#1E88E5]" data-id="element-450" />
                              <span className="text-sm text-gray-700" data-id="element-451">
                                {point}
                              </span>
                            </label>)}
                        </div>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-452">
                        <label className={labelClass} data-id="element-453">
                          Autres points à aborder (Optionnel)
                        </label>
                        <textarea name="autresPoints" rows={2} className={inputClass} placeholder="Précisez d'autres besoins spécifiques..." data-id="element-454"></textarea>
                      </div>
                      <div className="space-y-2" data-id="element-455">
                        <label className={labelClass} data-id="element-456">
                          Période souhaitée *
                        </label>
                        <input name="periodeSouhaitee" type="text" required className={inputClass} placeholder="Ex: Mois prochain" data-id="element-457" />
                      </div>
                      <div className="space-y-2" data-id="element-458">
                        <label className={labelClass} data-id="element-459">Durée souhaitée *</label>
                        <input name="dureeSouhaitee" type="text" required className={inputClass} placeholder="Ex: 1 semaine" data-id="element-460" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-461">
                        <label className={labelClass} data-id="element-462">
                          Observations particulières (Optionnel)
                        </label>
                        <textarea name="observations" rows={2} className={inputClass} placeholder="Informations complémentaires utiles..." data-id="element-463"></textarea>
                      </div>
                    </div>}

                  <Button type="submit" className="w-full text-lg py-6" disabled={isSubmitting} data-id="element-464">
                    {isSubmitting ? <>
                        <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-465" />
                        Envoi en cours...
                      </> : 'Envoyer la demande'}
                  </Button>
                </form>}
            </div>
          </div>
        </div>}
    </Layout>;
}